import ThirdpartyUnlinkModal from './ThirdpartyUnlinkModal';

export default ThirdpartyUnlinkModal;
